/**
 * react-router хранит позицию в стеке истории в `history.state.idx`.
 * idx === 0 означает, что назад откатываться некуда (прямой вход по ссылке),
 * и navigate(-1) закрыл бы Mini App вместо навигации внутри него.
 */
export function canGoBack(): boolean {
  return ((window.history.state as { idx?: number } | null)?.idx ?? 0) > 0;
}
